import * as moment from "moment"
import * as lookup from "../../../../../static/lookup.json"
import * as dataLayerLookup from "../../../../../static/dataLayerEventTrigger.json"
import { getAge } from "../../helperFunctions"
import { MD5 } from "crypto-js"
import { normalizeSpaces } from "../../../../shared/functions"
const CryptoJS = require('crypto-js');

export function promise2ProtectDataLayer(allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyStateData){
    var allJourneyData = allJourneyDataResponse
    const dateofbirth = allJourneyData?.lifeAssuredDetails?.dob;
    const spouseDateOfBirth = allJourneyData?.spouseDetails?.dob
    const nomineeDateOfBirth = allJourneyData?.nominees?.[0]?.dob
    const emailID = allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId?.toLowerCase();
    const mobileNo = allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo;
    let encryptedEmail  = emailID? MD5(emailID)?.toString() : ''
    let encryptedMobileNo = mobileNo? MD5(mobileNo)?.toString() : ''
    const policyTerm = Number(allJourneyData?.productDetails?.policyTerm) || "";
    const riders = allJourneyData?.productDetails?.riders?.rider
    var optionalBuiltInCoverArray = []
    var optionalBuiltInCover =''
    // let addOnsCalc
    var spouseOptionalBuiltInCoverArray = []
    var spouseOptionalBuiltInCover = ''
    var spouse = allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02" ? "YES" : "NO"
    var PremiumAmount = Number(allJourneyData?.basicDetails?.premium) || Number(allJourneyData?.premium) || "";
    var ProductCode = '90073';
    var products = [];
    products.push({
      'id': ProductCode,                               //Product Code
      'name': 'Promise 2 Protect Plan',   //name of the Product
      'category': 'Term',                     //Category of the Product
      'price': allJourneyData?.basicDetails?.premium || allJourneyData?.premium,                  //Product Price
      'quantity': '1'                         //Number of Products Purchased
    })

    const nomineeEmailId = allJourneyData?.nominees?.[0]?.["contactDetails.emailId"] || allJourneyData?.nominees?.[0]?.contactDetails?.emailId
    let spouseCover

    if(allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02"){
        spouseCover = "YES"
    }else if(allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "01"){
        spouseCover = "NO"
    }else{
        spouseCover = ""
    }

    const storedDataLayer = JSON.parse(sessionStorage.getItem("dataLayer") || "{}");
    const isResidentDetailsSubmitted = sessionStorage.getItem("isResidentDetailsSubmitted") || false
    const isNomineeDetailsSubmitted = sessionStorage.getItem("isNomineeDetailsSubmitted") || false
    const isSpouseDetailsSubmitted = sessionStorage.getItem("isSpouseDetailsSubmitted") || false
    const isCustomiseDetailsSubmitted = sessionStorage.getItem("isCustomiseDetailsSubmitted") || false
    const paymentDataLayer = JSON.parse(sessionStorage.getItem("paymentDataLayer") || "{}")
    const medicalDataLayer = JSON.parse(sessionStorage.getItem("medicalDataLayer") || "{}")

    var dynamicEvent
    var clientId
    try {
      let cookies = document.cookie
      let cookieArray = cookies.split(";")
      if (cookieArray && cookieArray.length) {
          let gaTagCookie = cookieArray.find(element => {
          if (element.includes("_ga=")) {
            return element.split(".")
          }
        })
        if (gaTagCookie) {
            let gaTagCookieSplit = gaTagCookie.split(".")
            if (gaTagCookieSplit && gaTagCookieSplit.length) {
                clientId = `${gaTagCookieSplit[gaTagCookieSplit.length - 2]}.${
                    gaTagCookieSplit[gaTagCookieSplit.length - 1]
                }`
          } else {
            clientId = ""
        }
        } else {
          clientId = ""
        }
    } else {
        clientId = ""
    }
    } catch (err) {
      console.log("Error geting google tag", "err")
    }
    let totalMonthlyPremium 
    var tax = Number(PremiumAmount - Math.round(PremiumAmount/1.18))
    try{
        if(PremiumAmount !== ""){
            if(allJourneyData?.productDetails?.premiumFrequency === "12" ){
                totalMonthlyPremium = Number(PremiumAmount/12)
            }else if(allJourneyData?.productDetails?.premiumFrequency === "01"){
                totalMonthlyPremium = Number(PremiumAmount)
            }else if(allJourneyData?.productDetails?.premiumFrequency === "03"){
                totalMonthlyPremium = Number(PremiumAmount/4)
            }else if(allJourneyData?.productDetails?.premiumFrequency === "06"){
                totalMonthlyPremium = Number(PremiumAmount/6)
            }else if(allJourneyData?.productDetails?.premiumFrequency === "SINGLE PREMIUM"){
                totalMonthlyPremium = Number((PremiumAmount/policyTerm)/12)
            }
        }
        else{
            totalMonthlyPremium = ""
        }
        }catch(err){
        console.log(err,"premium error")
    }
    var monthlyPremium
    var premium
    if(totalMonthlyPremium){
        monthlyPremium = (totalMonthlyPremium - tax)
        premium = (totalMonthlyPremium * 12)
    }else{
        monthlyPremium = ""
        premium = ""
    }
    var userType
    if(allJourneyData?.basicDetails?.existingCustomer){
        userType = allJourneyData?.basicDetails?.existingCustomer === "N" ? "New User" : "Returning User"
    }else{
        userType = ""
    }
    window.dataLayer = window.dataLayer || [];
    let lastDataLayerElement
    if(window.dataLayer.length){
        lastDataLayerElement = window.dataLayer[window.dataLayer.length -1]
    }else{
        lastDataLayerElement = {}
    }

    let paymentMode 
    if(allJourneyData?.transactionDetails?.transactions){
        paymentMode = allJourneyData?.transactionDetails?.transactions[allJourneyData?.transactionDetails?.transactions?.length - 1]?.paymentMethod
    }else{
        paymentMode = journeyStateData?.paymentDecryptData?.paymentMethod
    }

    let paymentOption 
    if(allJourneyData?.basicDetails?.paymentOption){
        if(allJourneyData?.basicDetails?.paymentOption === "N"){
            paymentOption = "paynow"
        }else {
            paymentOption = ""
        }
    }else if(allJourneyData?.paymentStep){
        if(allJourneyData?.paymentStep === "N"){
            paymentOption = "paynow"
        }else {
            paymentOption = ""
        }
    }else{
        paymentOption = ""
    }

    let paymentFrequency
    if(journeyStateData?.lastPage === 0 && journeyStateData?.lastSection > 2){
        paymentFrequency = lookup?.premiumFrequency[0][allJourneyData?.productDetails?.premiumFrequency] || ""
    }else if(journeyStateData?.lastPage > 0){
        paymentFrequency = lookup?.premiumFrequency[0][allJourneyData?.productDetails?.premiumFrequency] || ""
    }else{
        paymentFrequency = ""
    }

    // window.dataLayer = []
    if(e === "previous"){
        dynamicEvent = dataLayerLookup?.Promise2ProtectJourney?.[sectionId]?.previousButtonEvent?.eventName 
        }else if(e === "proceed"){
            dynamicEvent = dataLayerLookup?.Promise2ProtectJourney?.[sectionId]?.proceedButtonEvent?.eventName
        }else if(e === "landing"){
            dynamicEvent = dataLayerLookup?.Promise2ProtectJourney?.[sectionId]?.landingPageEvent?.eventName
        }else {
            console.log(dataLayerLookup)
            dynamicEvent = dataLayerLookup?.Promise2ProtectJourney?.[sectionId]?.componentKeyEvent?.[componentFormControlKey]?.eventName
        }
        let pageNameHaveSource = window.location.href?.includes("source")
        if(dynamicEvent === "iSelect_Buy_PersonalDetail_Landed" && !pageNameHaveSource){
            return 
        }

    const urlParams = new URLSearchParams("?" + window?.location?.href?.split("?")?.[1])
    let sourceParameter
    let gclidParameter
    if(urlParams){
        sourceParameter = urlParams.get("source")
        gclidParameter = urlParams.get("gclid");
    }
    let nomineeRelationship = ''
    if (allJourneyData?.nominees?.[0]?.relationshipWithLa){
        if (allJourneyData?.nominees?.[0]?.gender === "M"){
            nomineeRelationship = lookup?.nomineeRelationshipWithLAMale?.[0][allJourneyData?.nominees?.[0]?.relationshipWithLa]
        }else{
            nomineeRelationship = lookup?.nomineeRelationshipWithLAFemale?.[0][allJourneyData?.nominees?.[0]?.relationshipWithLa]
        }
    }else{
        if (journeyStateData?.nomineeDataSecond?.gender === "M"){
            nomineeRelationship = lookup?.nomineeRelationshipWithLAMale?.[0][journeyStateData?.nomineeDataSecond?.relationship]
        }else if (journeyStateData?.nomineeDataSecond?.gender){
            nomineeRelationship = lookup?.nomineeRelationshipWithLAFemale?.[0][journeyStateData?.nomineeDataSecond?.relationship]
        }
    }

    let nomineeRelationship2 = ''
    if (allJourneyData?.nominees?.[1]?.relationshipWithLa){
        if (allJourneyData?.nominees?.[1]?.gender === "M"){
            nomineeRelationship2 = lookup?.nomineeRelationshipWithLAMale?.[0][allJourneyData?.nominees?.[1]?.relationshipWithLa]
        }else{
            nomineeRelationship2 = lookup?.nomineeRelationshipWithLAFemale?.[0][allJourneyData?.nominees?.[1]?.relationshipWithLa]
        }
    }

    let appointeeDetails = {}
    if (allJourneyData?.nominees?.length > 0){
        for (let i = 0;i<allJourneyData.nominees.length;i++){
            const nominee = allJourneyData.nominees[i]
            if (nominee.appointee){
                appointeeDetails = nominee.appointee
                break;
            }
        }
    }

    const generateLeadId = appNum => {
        if (!appNum) return ""
        const appStr = appNum.toString();
        const prefix = appStr.slice(0, 3); // First 3 digits
        const baseAppNum = Number(prefix + '0000000'); // Dynamic base
        const baseLeadId = 1100000000;
        return (baseLeadId + (Number(appNum) - baseAppNum)).toString().padStart(10, '0');
    };

        if(dynamicEvent){
            const formData = {
                event: dynamicEvent,
                ProductName: "Promise2Protect",
                ProductCategory: "Term",
                PageType: "Buying Journey",
                PageSection: dataLayerLookup?.Promise2ProtectJourney?.[sectionId]?.sectionName || "",
                PolicyType: '',
                SectionName: dataLayerLookup?.Promise2ProtectJourney?.[sectionId]?.sectionName || "",
                ClientID: clientId,
                LeadID: generateLeadId(allJourneyData?.basicDetails?.applicationNumber || sessionStorage.getItem("appNo")),
                leadFormType: "",
                Source: sourceParameter ? lookup?.sourceChannelLookup_lowercase?.[0]?.[sourceParameter?.toLowerCase()] : journeyStateData?.channel ? lookup?.sourceChannelLookup_lowercase?.[0][journeyStateData?.channel?.toLowerCase()] : "",
                UserType: journeyStateData?.dedupeResult === true ? "Returning User" : "New User",
                Name: normalizeSpaces(allJourneyData?.lifeAssuredDetails?.fullName) || '',
                MobileNumber: encryptedMobileNo,
                userMob: allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo ?  CryptoJS.SHA256(`${allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCode}${allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo}`).toString() : '',
                mobile_hash:  allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo ? btoa(allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo) : "",
                userEmailId: allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId ?  CryptoJS.SHA256(`${allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId.toLowerCase()}`).toString() : '',
                emailID_hash:  allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId ? btoa(allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId?.toLowerCase()) : "",
                EmailID: encryptedEmail,
                Gender: lookup?.gender?.[0][allJourneyData?.lifeAssuredDetails?.gender] || "",
                DOB: dateofbirth ? moment.unix(dateofbirth).format('MM/YYYY') : '',
                Age: dateofbirth ? getAge(dateofbirth) : '',
                City: isResidentDetailsSubmitted ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.cityDistrict ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.cityDistrict : '' : "",
                TobaccoConsumer: allJourneyData?.lifeAssuredDetails?.personalDetails?.smoking ? lookup?.["yesNo"][0][allJourneyData?.lifeAssuredDetails?.personalDetails?.smoking] : '',
                Education: allJourneyData?.lifeAssuredDetails?.employmentDetails?.education ? lookup?.["education"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.education] : '',
                AnnualIncome: allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome ? Number(allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome) : '',
                ApplicationNumber: allJourneyData?.basicDetails?.applicationNumber ? allJourneyData?.basicDetails?.applicationNumber : '',
                SumAssured: allJourneyData?.productDetails?.sumAssured ? allJourneyData?.productDetails?.sumAssured : '',
                PolicyTerm: allJourneyData?.productDetails?.policyTerm ? allJourneyData?.productDetails?.policyTerm + " years" :  "",
                Country: lookup?.countryCodeToCountry?.[0][allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap] || "",
                PinCode: isResidentDetailsSubmitted ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.pinCode || "" : "",
                State: isResidentDetailsSubmitted ? lookup?.state[0][allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.state] || "" : "",
                Occupation: isResidentDetailsSubmitted ? lookup?.occupation?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.occupation] || "" : "",
                NatureOfDuties: isResidentDetailsSubmitted ? lookup?.natureOfOccupation?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.natureOfOccupation] || "" : "",
                ExistingSumAssured: isResidentDetailsSubmitted ? allJourneyData?.lifeAssuredDetails?.existingSumAssured || '' : "",
                IndianCarRegNo: isResidentDetailsSubmitted ? allJourneyData?.lifeAssuredDetails?.carRegistration || '' : "",
                PlanOption: isCustomiseDetailsSubmitted ? allJourneyData?.productDetails?.planOption ? lookup.p2pLatestPlanCode[allJourneyData?.productDetails?.planOption] || "" : '' : "",
                CoverageOption: isCustomiseDetailsSubmitted ? lookup?.coverOption?.[0][allJourneyData?.productDetails?.coverOption] || '' : "",
                Term: allJourneyData?.productDetails?.policyTerm ? allJourneyData?.productDetails?.policyTerm + " years" :  '',
                PremiumPaymentTerm: isCustomiseDetailsSubmitted ? allJourneyData?.productDetails?.premiumPaymentTerm ? allJourneyData?.productDetails?.premiumPaymentTerm + " years" : '' : "",
                PaymentFrequency: isCustomiseDetailsSubmitted ? paymentFrequency || '' : "",
                BenefitPayoutOption: isCustomiseDetailsSubmitted ? lookup?.benefitOption?.[0][allJourneyData?.productDetails?.benefitOption] || '' : "",
                PremiumPaymentOption: '',
                WholeLifeProtectionOption: '',
                TotalPremium: journeyStateData?.premium ? Number(journeyStateData?.premium) : storedDataLayer?.totalPremium ? Number(storedDataLayer?.totalPremium) : "",
                BenefitPayoutMonthlyInst: isCustomiseDetailsSubmitted ? lookup.benefitPayoutOptionsIndIselect360[0]?.[allJourneyData?.productDetails?.benefitPayoutOptionsInd] || '' : "",
                BenefitPayoutLumpSumPercent: isCustomiseDetailsSubmitted ? allJourneyData?.productDetails?.proportion ? String(Number(allJourneyData?.productDetails?.proportion) * 100) + "%" : '' : "",
                SpouseCover: isSpouseDetailsSubmitted ? allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure ? (allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02" ? "Yes" : "No") : '' : "",
                SpouseWorking: isSpouseDetailsSubmitted ? allJourneyData?.productDetails?.spouseLaDetails?.spouseStatus ? (allJourneyData?.productDetails?.spouseLaDetails?.spouseStatus === "W" ? "Yes" : "No") : '' : "",
                SpouseName: isSpouseDetailsSubmitted ? (allJourneyData?.spouseDetails?.fullName?.trim() === '.') ? '' : normalizeSpaces(allJourneyData?.spouseDetails?.fullName?.trim()) : "",
                SpouseGender: isSpouseDetailsSubmitted ? allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02" ? lookup?.gender?.[0][allJourneyData?.spouseDetails?.gender] || "" : "" : "",
                SpouseTobacco: isSpouseDetailsSubmitted ? allJourneyData?.spouseDetails?.personalDetails?.smoking ? lookup?.["yesNo"][0][allJourneyData?.spouseDetails?.personalDetails?.smoking] : '' : "",
                SpouseDOB: isSpouseDetailsSubmitted ? allJourneyData?.spouseDetails?.dob ? moment.unix(allJourneyData?.spouseDetails?.dob ).format('MM/YYYY') : '' : "",
                SpouseSumAssured: isSpouseDetailsSubmitted ? allJourneyData?.productDetails?.spouseLaDetails?.spouseSa || '' : "",
                SpouseBenefitPayoutOption: isSpouseDetailsSubmitted ? allJourneyData?.productDetails?.spouseLaDetails?.spousebenAmtRcvInd ? lookup?.benefitOption?.[0][allJourneyData?.productDetails?.spouseLaDetails?.spousebenAmtRcvInd] : '' : "",
                SpouseBenefitPayoutMonthlyInst: isSpouseDetailsSubmitted ? lookup.benefitPayoutOptionsIndIselect360[0]?.[allJourneyData?.productDetails?.spouseLaDetails?.spouseBenefitPayoutOptionsInd] || '' : "",
                SpouseRiderSumAssured: '',
                Premium: journeyStateData?.premiumWithoutTax ? Number(journeyStateData?.premiumWithoutTax) : storedDataLayer?.premium ? Number(storedDataLayer?.premium) : "",
                SpouseBenefitPayoutLumpSumPercent:isSpouseDetailsSubmitted ? allJourneyData?.productDetails?.spouseLaDetails?.spouseProportion ? String(Number(allJourneyData?.productDetails?.spouseLaDetails?.spouseProportion) * 100) + "%" : '' : "",
                "Identity/AgeProof": isResidentDetailsSubmitted ? storedDataLayer?.proceedWith === "ekyc" ? "e-KYC Verified" : lookup.ID_PROOF[0]?.[allJourneyData?.lifeAssuredDetails?.proofOfIdentity] || '' : "",
                MaritalStatus: allJourneyData?.lifeAssuredDetails?.maritalStatus ?  (allJourneyData?.lifeAssuredDetails?.maritalStatus === "M" ? "Yes" : "No") : '',
                ResidentialStatus: allJourneyData?.lifeAssuredDetails?.residentStatus ? lookup?.["residentStatus"][0][allJourneyData?.lifeAssuredDetails?.residentStatus] : '',
                Citizenship: allJourneyData?.lifeAssuredDetails?.citizenship || '',
                Nationallity: allJourneyData?.lifeAssuredDetails?.nationality || '',
                BirthCountry: allJourneyData?.lifeAssuredDetails?.countryOfBirth || '',
                NatureOfIndustry: allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerIndustry ? lookup?.["natureOfIndustry"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerIndustry] : '',
                InsuranceRepository: allJourneyData?.lifeAssuredDetails?.amlAddendum?.eInsurance?.insuranceRepository ? lookup?.["insuranceRepository"]?.[0][allJourneyData?.lifeAssuredDetails?.amlAddendum?.eInsurance?.insuranceRepository] : '',
                IsStaffMember: lookup.yesNo[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.staff] || '',
                NomineeDOB: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[0]?.dob ? moment.unix(allJourneyData?.nominees?.[0]?.dob).format('MM/YYYY') : journeyStateData?.nomineeDataSecond?.dob ? moment.unix(journeyStateData?.nomineeDataSecond?.dob).format('MM/YYYY') : '' : "",
                NomineeRelationship: isNomineeDetailsSubmitted ? nomineeRelationship : "",
                NomineeGender: isNomineeDetailsSubmitted ?  allJourneyData?.nominees?.[0]?.gender ? lookup?.gender?.[0][allJourneyData?.nominees?.[0]?.gender] : journeyStateData?.nomineeDataSecond?.gender ? lookup?.gender?.[0][journeyStateData.nomineeDataSecond.gender] : '' : "",
                NomineeEmail: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[0]?.["contactDetails.emailId"] ? CryptoJS.MD5(allJourneyData?.nominees?.[0]?.["contactDetails.emailId"]?.toLowerCase())?.toString() : '' : "",
                NomineeMob: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[0]?.["contactDetails.mobileNo"] ? CryptoJS.MD5(allJourneyData?.nominees?.[0]?.["contactDetails.mobileNo"]?.toLowerCase())?.toString() : '' : "",
                NomineeCount: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.length ? allJourneyData.nominees.length.toString() : "" : "",
                NomineeDOB2: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[1]?.dob ? moment.unix(allJourneyData?.nominees?.[1]?.dob).format('MM/YYYY') : '' : "",
                NomineeRelationship2: isNomineeDetailsSubmitted ? nomineeRelationship2 : "",
                NomineeGender2: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[1]?.gender ? lookup?.gender?.[0][allJourneyData?.nominees?.[0]?.gender] : '' : "",
                NomineeEmail2: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[1]?.["contactDetails.emailId"] ? CryptoJS.MD5(allJourneyData?.nominees?.[1]?.["contactDetails.emailId"]?.toLowerCase())?.toString() : '' : "",
                NomineeMob2: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[1]?.["contactDetails.mobileNo"] ? CryptoJS.MD5(allJourneyData?.nominees?.[1]?.["contactDetails.mobileNo"]?.toLowerCase())?.toString() : '' : "",
                APE: journeyStateData?.annualPremiumEquivalent ? Number(journeyStateData?.annualPremiumEquivalent) : storedDataLayer?.annualPremiumEquivalent ? Number(storedDataLayer?.annualPremiumEquivalent) : "",
                KYC: journeyStateData?.proceedWith ? journeyStateData?.proceedWith : storedDataLayer.proceedWith ? lookup.proceedWithMapper[storedDataLayer.proceedWith] : "",
                PartnerName: sourceParameter || (journeyStateData?.channel === "A" ? "HSBC" : journeyStateData?.channel || ""),
                gclid: gclidParameter || "",
                AppointeeName: appointeeDetails?.fullName || '',
                AppointeeRelation: lookup.appointeeRelationshipWithNominee[0][appointeeDetails?.relationshipWithNominee] || '',
                AppointeeDOB: appointeeDetails?.dob ? moment.unix(appointeeDetails.dob).format('MM/YYYY') : '',
                MedAppointmentCity: "",
                MedAppointmentDate: medicalDataLayer?.date || "",
                MedAppointmentTime: medicalDataLayer?.time || "",
                order_ID: paymentDataLayer?.order_id || "",
                NachStatus: (allJourneyData?.basicDetails?.isPhysicalMandateOpt === true || allJourneyData?.basicDetails?.isPhysicalMandateOpt === "true") ? (allJourneyData?.basicDetails?.nachStatus === true || allJourneyData?.basicDetails?.nachStatus === "true") ? "Success" : "Fail" : (allJourneyData?.basicDetails?.isPhysicalMandateOpt === false || allJourneyData?.basicDetails?.isPhysicalMandateOpt === "false") ? (allJourneyData?.basicDetails?.enachSuccess === true) ? "Success" : "Fail" : paymentDataLayer?.nachStatus || "" ,
                NachType: (allJourneyData?.basicDetails?.isPhysicalMandateOpt === true || allJourneyData?.basicDetails?.isPhysicalMandateOpt === "true") ? "Physical Mandate" : ((allJourneyData?.basicDetails?.isPhysicalMandateOpt === false || allJourneyData?.basicDetails?.isPhysicalMandateOpt === "false") ? "E-Mandate" :  paymentDataLayer?.nachType || ''),
                PaymentOption: paymentOption,
                PaymentMode: paymentMode || lastDataLayerElement?.PaymentMode || "",
                MedicalCheckUp: '',
                SpouseMedicalCheckup: allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02" ? "" : ''
            };

            window.dataLayer.push(formData)
        }

}
